


































































































import { Component, Vue } from 'vue-property-decorator';
import { WorkerDetailsModule } from '@/store/modules/workerDetails'
import VerifiableAttribute from '@/components/Shared/VerifiableAttribute.vue';
import GiganautVue from '@/components/Shared/GiganautVue';
import WorkerQualificationCreate from '@/components/WorkerQualifications/WorkerQualificationCreate.vue';
import WorkerQualificationEdit from '@/components/WorkerQualifications/WorkerQualificationEdit.vue';
import { WorkerQualificationDto } from '@/models/Workers/WorkerQualificationDto';

@Component({
  name: 'WorkerQualifications',
  components: { VerifiableAttribute, WorkerQualificationCreate, WorkerQualificationEdit }
})
export default class extends GiganautVue {

    deleteDialog = false;
    deleting = false;
    qualificationToDelete: WorkerQualificationDto | null = null;

    async created() {
       await WorkerDetailsModule.getQualifications();
    }

    get loading() {
        return WorkerDetailsModule.loadingQualifications;
    }

    get qualifications() {
        return WorkerDetailsModule.qualifications;
    }

    confirmDelete(qualification: WorkerQualificationDto) {
        this.qualificationToDelete = qualification;
        this.deleteDialog = true;
    }

    async deleteQualification() {
        if (!this.qualificationToDelete) return;
        this.deleting = true;
        await WorkerDetailsModule.deleteQualification(this.qualificationToDelete.id);
        this.deleting = false;
        this.deleteDialog = false;
        this.qualificationToDelete = null;
    }

}
